export default __webpack_public_path__ + "static/media/Inter-Regular.e148c4a1.woff";